import React from 'react';
import { Layout, Menu, Button, Icon } from 'antd';
import LogoWhite from '../../assets/images/clear-h2o-logo-white.svg';


const { Sider } = Layout;

const SIDEBAR_ITEMS = [
    { icon: 'home', label: 'Overview', key: 'overview' },
    { icon: 'search', label: 'Search Bookings', key: 'search' },
    { icon: 'ordered-list', label: 'Services List', key: 'services' },
    { icon: 'rocket', label: 'Manage Holiday', key: 'holiday' },
];

const style = {
    logoWrapper: {
        height: 32,
        margin: 16,
        marginBottom: 40,
        textAlign: 'center',
    },
    logo: {
        width: '100%',
    },
    button: {
        position: 'absolute',
        left: 16,
        bottom: 16,
        width: 'calc(100% - 32px)',
    },
};

const Sidebar = props => {
    const {
        onMenuItemChange,
        handleLogout,
        isLogoutLoading,
    } = props;

    return (
        <Sider 
            collapsible={false} 
            collapsed={false}
        >
            <div style={style.logoWrapper}>
                <img style={style.logo} src={LogoWhite} alt="Clear H2O Logo" />
            </div>
            <Menu 
                theme="dark" 
                defaultSelectedKeys={['overview']}
                onSelect={onMenuItemChange}
            >
                {
                    SIDEBAR_ITEMS.map(({ icon, label, key }) => 
                        <Menu.Item key={key}>
                            <Icon type={icon} />
                            { label  }
                        </Menu.Item>
                    )
                }
            </Menu>
            <Button
                loading={isLogoutLoading}
                onClick={handleLogout}
                style={style.button}
                ghost 
            >
                <Icon type="logout" />
                Logout
            </Button>
        </Sider>
    );
};

export default Sidebar;
